export class Motivation {
  public id: number;
  public name: string;
  public closed_at: Date;
  public created_at: Date;

  constructor(server_obj) {
    this.id = Number(server_obj["id"]);
    this.name = server_obj["name"];

    if (server_obj["closed_at"]) {
      this.closed_at = new Date(server_obj["closed_at"].replace(/-/g, "/"));
    } else {
      this.closed_at = null;
    }

    if (server_obj["created_at"]) {
      this.created_at = new Date(server_obj["created_at"].replace(/-/g, "/"));
    } else {
      this.created_at = null;
    }
  }
}
